import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CustomChatbot } from '../../shared/models/custom-chatbot';
import { CoreResponse } from '../models/core-response';
import { CoreBotRequest } from '../models/core-bot-request';
import { CoreBotResponse } from '../models/core-bot-response';

@Injectable()
export class CustomChatbotService {
    private baseUrl = environment.apiEndpoint + '/CustomChatbot';

    constructor(private http: HttpClient) {
    }

    getAllCustomChatbots(): Observable<CoreResponse<CustomChatbot>> {
        return this.http.get<CoreResponse<CustomChatbot>>(`${this.baseUrl}/`);
    }

    makeCustomChatbotRequest(request: CoreBotRequest): Observable<CoreBotResponse> {
        return this.http.post<CoreBotResponse>(this.baseUrl + '/request', request);
    }

    insertCustomChatbot(customChatbot: CustomChatbot): Observable<CoreResponse<CustomChatbot>> {
        return this.http.post<CoreResponse<CustomChatbot>>(this.baseUrl, customChatbot)
    }

    updateCustomChatbot(customChatbot: CustomChatbot): Observable<CoreResponse<CustomChatbot>> {
        return this.http.put<CoreResponse<CustomChatbot>>(this.baseUrl, customChatbot);
    }

    deleteCustomChatbot(customChatbotId: number): Observable<CoreResponse<number>> {
        return this.http.delete<CoreResponse<number>>(`${this.baseUrl}/${customChatbotId}`);
    }
}
